interface AboutSectionProps {
  lang: 'pt' | 'en';
}

export function AboutSection({ lang }: AboutSectionProps) {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const content = {
    pt: {
      label: 'O PROBLEMA',
      line1: 'Estás a perder leads',
      line2: 'todos os dias',
      description:
        'Não é uma questão de qualidade do teu produto. É uma questão de timing e follow-up. Muitos leads nunca recebem resposta e acabam por ser perdidos. Hoje, quem responde primeiro, tem vantagem.',
      stats: [
        { number: '21×', label: 'mais conversões quando respondes a um lead em menos de 5 minutos' },
        { number: '60%', label: 'dos leads nunca recebem follow-up' },
        { number: '4–24h', label: 'é o tempo médio de resposta nas PMEs' },
      ],
      cta: 'Ver a Solução →',
    },
    en: {
      label: 'THE PROBLEM',
      line1: 'You are losing leads',
      line2: 'every single day',
      description:
        "Not because your product is bad. Because nobody responds in time — and 60% of leads never receive a single follow-up. In today's world, whoever responds first, sells first.",
      stats: [
        { number: '21×', label: 'more conversions when responding in under 5 min' },
        { number: '60%', label: 'of leads never receive a follow-up' },
        { number: '4–24h', label: 'average SME response time' },
      ],
      cta: 'See the Solution →',
    },
  };

  const c = content[lang];

  return (
    <section id="problema" className="py-24">
      <div className="container mx-auto px-6">
        <div className="text-center max-w-5xl mx-auto">

          {/* Section label */}
          <p className="text-[11px] font-medium tracking-[0.15em] text-violet-400 uppercase mb-6">
            {c.label}
          </p>

          {/* Headline */}
          <h2 className="text-4xl md:text-[48px] font-light leading-tight tracking-[0.02em] mb-10">
            <span className="text-white">{c.line1}</span>
            <br />
            <span className="bg-gradient-to-r from-violet-400 to-purple-400 bg-clip-text text-transparent">{c.line2}</span>
          </h2>

          {/* Description */}
          <p className="text-gray-400 text-base leading-[1.7] font-normal max-w-3xl mx-auto mb-14">
            {c.description}
          </p>

          {/* Stats */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-14 max-w-3xl mx-auto">
            {c.stats.map((stat, i) => (
              <div
                key={i}
                className="border border-white/10 rounded-xl p-6 bg-white/5 backdrop-blur-sm hover:border-violet-400/40 transition-all duration-300"
              >
                <p className="text-3xl font-extralight bg-gradient-to-r from-violet-400 to-purple-400 bg-clip-text text-transparent mb-2">
                  {stat.number}
                </p>
                <p className="text-gray-400 text-sm font-light leading-snug">
                  {stat.label}
                </p>
              </div>
            ))}
          </div>

          {/* CTA Button */}
          <div className="flex justify-center">
            <a
              href="#servicos"
              onClick={(e) => { e.preventDefault(); scrollToSection('servicos'); }}
              className="group relative bg-transparent border border-gray-600 text-white px-8 py-4 rounded-xl text-base font-medium transition-all duration-300 hover:border-purple-400 hover:bg-purple-500/10 whitespace-nowrap cursor-pointer"
            >
              <span className="relative z-10">{c.cta}</span>
            </a>
          </div>

        </div>
      </div>
    </section>
  );
}
